import {
	NAVIGATION_HOVER_ID_ATTR,
	useNavigationTreeStore,
} from "@ext/navigation/catalog/SidebarNavigation/store/navigationTreeStore";
import { type PointerEvent, useCallback } from "react";

export const useNavigationHoverTracking = (isResizing: boolean) => {
	const setHoveredNavigationId = useNavigationTreeStore((state) => state.setHoveredNavigationId);

	const trackHoveredItem = useCallback(
		(event: PointerEvent<HTMLDivElement>) => {
			if (isResizing) return;
			const target = event.target instanceof Element ? event.target : null;
			const hoveredItem = target?.closest<HTMLElement>(`[${NAVIGATION_HOVER_ID_ATTR}]`);
			setHoveredNavigationId(hoveredItem?.getAttribute(NAVIGATION_HOVER_ID_ATTR) ?? "sidebar");
		},
		[isResizing, setHoveredNavigationId],
	);

	const hoverSidebar = useCallback(() => setHoveredNavigationId("sidebar"), [setHoveredNavigationId]);

	const clearHover = useCallback(() => {
		if (isResizing) return;
		setHoveredNavigationId(null);
	}, [isResizing, setHoveredNavigationId]);

	return { trackHoveredItem, hoverSidebar, clearHover };
};
